class TokuisakiForm {

    static initComponent() {
        document.querySelectorAll<HTMLFormElement>("[data-action=TokuisakiForm]").forEach((form) => {
            new TokuisakiForm(form);
        });
    }

    private constructor(form: HTMLFormElement) {
        const mode = form.dataset.mode; // 'create' or 'update'
        const tokuisakiCodeInput = form.querySelector<HTMLInputElement>("[name=tokuisakiCode]");
        if (!tokuisakiCodeInput) return;

        // エラーメッセージ表示用の要素を作成
        const feedbackDiv = document.createElement('div');
        feedbackDiv.className = 'invalid-feedback';
        tokuisakiCodeInput.parentNode!.insertBefore(feedbackDiv, tokuisakiCodeInput.nextSibling);

        const initialCode = tokuisakiCodeInput.value;

        tokuisakiCodeInput.addEventListener('blur', () => {
            const code = tokuisakiCodeInput.value.trim();
            if (!code) return;

            // 編集画面で得意先コードが変更されていない場合はスキップ
            if (mode === 'update' && code === initialCode) return;

            fetch('/api/tokuisakiChk?tokuisaki_code=' + encodeURIComponent(code))
                .then(response => response.json())
                .then(data => {
                    if (data.exists) {
                        tokuisakiCodeInput.classList.add('is-invalid');
                        feedbackDiv.textContent = '入力された得意先ｺｰﾄﾞは既に登録されています。';
                        tokuisakiCodeInput.value = mode === 'update' ? initialCode : '';
                        tokuisakiCodeInput.focus();
                    }
                });
        });

        // 入力時にエラー表示をクリア
        tokuisakiCodeInput.addEventListener('input', () => {
            tokuisakiCodeInput.classList.remove('is-invalid');
            feedbackDiv.textContent = '';
        });
    }
}

export default TokuisakiForm;
